import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { DemandaService } from 'src/app/core/services/demanda.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Demanda } from 'src/app/shared/models/demanda';

@Component({
  selector: 'app-dashboard-exibir',
  templateUrl: './dashboard-exibir.component.html',
  styleUrls: ['./dashboard-exibir.component.css']
})
export class DashboardExibirComponent implements OnInit {

  nomeUsuario = '';
  ultimoAcesso: string = null;
  carregandoAcesso = true;
  erroAcesso = false;
  breadCrumb;
  demandas: Demanda[] = [];
  carregandoDemandas = false;
  erroDemandas = false;

  constructor(private appComponent: AppComponent, private demandaService: DemandaService, private authenticationService: AuthenticationService) {

  }

  ngOnInit() {
    //this.appComponent.setTitulo(false);
    this.appComponent.setBreadcrumb(false);
    this.carregarDemandas();
    this.authenticationService.me().subscribe(dados => {
      this.nomeUsuario = dados.nome_pessoa || (dados.user && dados.user.name) || '';
      this.ultimoAcesso = dados.ultimo_acesso || null;
      this.carregandoAcesso = false;
    }, () => {
      this.erroAcesso = true;
      this.carregandoAcesso = false;
    });
  }

  carregarDemandas(): void {
    this.carregandoDemandas = true;
    this.erroDemandas = false;
    this.demandaService.minhasDemandas().subscribe(demandas => {
      this.demandas = demandas;
      this.carregandoDemandas = false;
    }, () => {
      this.erroDemandas = true;
      this.carregandoDemandas = false;
    });
  }

}
